"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var BlockStyleEventService_1 = __importStar(require("../../BlockStyleEventService/BlockStyleEventService"));
var blockConfigUtil_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/blockConfigUtil");
var GetCreateStyleTelemetryPayload_1 = __importDefault(require("./GetCreateStyleTelemetryPayload"));
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var PrepareStyles_1 = require("Project/Service/TCDCProjectConverter/PrepareStyles");
var SavedStyleService = (function () {
    function SavedStyleService($http, apiBaseUrl, telemetry, brandStore, styleMigrationService) {
        var _this = this;
        this.$http = $http;
        this.telemetry = telemetry;
        this.brandStore = brandStore;
        this.styleMigrationService = styleMigrationService;
        this.exclusionKeys = ["clonedFrom", "_id"];
        this.savedStyles = [];
        this.addStyle = function (style) { return __awaiter(_this, void 0, Promise, function () {
            var migratedStyle, response, newStyle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        delete style._id;
                        delete style.clonedFrom;
                        style.isFactoryStyle = false;
                        delete style.isMigrated;
                        delete style.migratedAt;
                        migratedStyle = this.styleMigrationService.handleStyleCreation(style);
                        return [4, this.$http.post(this.styleUrl, { style: migratedStyle })];
                    case 1:
                        response = _a.sent();
                        newStyle = response.data.message;
                        this.savedStyles = __spreadArray(__spreadArray([], __read(this.savedStyles), false), [newStyle], false);
                        return [2, newStyle];
                }
            });
        }); };
        this.deleteStyle = function (styleToBeDeleted) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.$http.delete("".concat(this.styleUrl, "/").concat(styleToBeDeleted._id))];
                    case 1:
                        _a.sent();
                        this.savedStyles = this.savedStyles.filter(function (style) {
                            return styleToBeDeleted._id !== style._id;
                        });
                        return [2, styleToBeDeleted];
                }
            });
        }); };
        this.renameStyle = function (styleToBeRenamed) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.$http.post("".concat(this.styleUrl, "/").concat(styleToBeRenamed._id), {
                            style: { name: styleToBeRenamed.name },
                        })];
                    case 1:
                        _a.sent();
                        this.savedStyles = this.savedStyles.map(function (style) {
                            if (styleToBeRenamed._id === style._id) {
                                return __assign(__assign({}, style), { name: styleToBeRenamed.name });
                            }
                            else {
                                return style;
                            }
                        });
                        return [2];
                }
            });
        }); };
        this.updateStyle = function (styleToBeUpdated_1, project_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([styleToBeUpdated_1, project_1], __read(args_1), false), Promise, function (styleToBeUpdated, project, updateType) {
                var newStyle;
                var _this = this;
                if (updateType === void 0) { updateType = commonTypes_1.UpdateType.New; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styleToBeUpdated.isFactoryStyle = false;
                            if (!styleToBeUpdated.clonedFrom) {
                                throw new Error("Something went wrong, please try again later.");
                            }
                            return [4, this.$http.post("".concat(this.styleUrl, "/").concat(styleToBeUpdated.clonedFrom), {
                                    style: styleToBeUpdated,
                                    updateType: updateType,
                                })];
                        case 1:
                            _a.sent();
                            newStyle = __assign(__assign({}, styleToBeUpdated), { _id: styleToBeUpdated.clonedFrom });
                            this.savedStyles = this.savedStyles.map(function (style) {
                                if (newStyle._id === style._id) {
                                    if (updateType === commonTypes_1.UpdateType.All) {
                                        _this.updateAllStyles(newStyle, style, project);
                                    }
                                    return __assign(__assign({}, style), newStyle);
                                }
                                else {
                                    return style;
                                }
                            });
                            return [2, {
                                    style: newStyle,
                                    updateType: updateType,
                                }];
                    }
                });
            });
        };
        this.getAllSavedStyles = function () { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isSavedStylesEmpty()) return [3, 3];
                        return [4, this.getStylesFromServer()];
                    case 1:
                        _a.sent();
                        return [4, this.migrateStyles()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2, this.savedStyles];
                }
            });
        }); };
        this.getSavedStylesCount = function () {
            return _this.savedStyles.length;
        };
        this.filterStylesByBlockType = function (blockType) {
            return _this.isSavedStylesEmpty()
                ? []
                : _this.savedStyles.filter(function (style) {
                    return style.blockType === (0, blockConfigUtil_1.getGroupedBlockType)(blockType);
                });
        };
        this.cloneSavedStyleToBlock = function (blockStyleStore, savedStyle) {
            blockStyleStore.setClonedFrom(savedStyle._id);
            var intersections = (0, lodash_1.intersection)((0, lodash_1.keys)(blockStyleStore.model), (0, lodash_1.keys)(savedStyle));
            intersections.forEach(function (key) {
                if (!_this.exclusionKeys.includes(key)) {
                    blockStyleStore.setStyleAttribute(key, (0, lodash_1.cloneDeep)(savedStyle[key]));
                }
            });
        };
        this.cloneSavedStyleToBlockAngular = function (block, savedStyle) {
            block.style.clonedFrom = savedStyle._id;
            var intersections = (0, lodash_1.intersection)((0, lodash_1.keys)(block.style), (0, lodash_1.keys)(savedStyle));
            intersections.forEach(function (key) {
                if (!_this.exclusionKeys.includes(key)) {
                    block.style[key] = (0, lodash_1.cloneDeep)(savedStyle[key]);
                }
            });
            var blockStyleEventEmitter = BlockStyleEventService_1.default.getEventEmitterByBlockId(block.$id);
            if (blockStyleEventEmitter) {
                blockStyleEventEmitter.emit(BlockStyleEventService_1.BLOCK_STYLE_CHANGE, block.style);
            }
        };
        this.trackCreateStyle = function (style, blockType, clonedFromId) {
            return _this.track("Block Styles Created", __assign({ block_styles_number: _this.getSavedStylesCount(), block_styles_saved_number: _this.getCustomStylesCount(), block_styles_saved_type: blockType }, (0, GetCreateStyleTelemetryPayload_1.default)(style, blockType, clonedFromId, _this.savedStyles)));
        };
        this.trackDeleteStyle = function (blockType) {
            return _this.track("Block Styles Deleted", {
                block_styles_number: _this.getSavedStylesCount(),
                block_styles_saved_number: _this.getCustomStylesCount(),
                block_styles_saved_type: blockType,
            });
        };
        this.getStylesFromServer = function () { return __awaiter(_this, void 0, Promise, function () {
            var styles;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.$http.get(this.styleUrl).then(function (res) {
                            return res.data.message;
                        })];
                    case 1:
                        styles = _a.sent();
                        styles.forEach(function (style) {
                            (0, PrepareStyles_1.prepareStyle)(style, _this.brandStore);
                            _this.clearEmptyObjects(style);
                            (0, blockConfigUtil_1.addHash)(style);
                        });
                        this.savedStyles = styles;
                        return [2];
                }
            });
        }); };
        this.getCustomStylesCount = function () {
            return _this.savedStyles.filter(function (style) { return !style.isFactoryStyle; }).length;
        };
        this.track = function (name, parameters) {
            return _this.telemetry.track(name, parameters || {}, {
                blockIntercom: true,
            });
        };
        this.isSavedStylesEmpty = function () {
            return !_this.savedStyles || !_this.savedStyles.length;
        };
        this.updateAllStyles = function (newStyle, oldStyle, project) {
            if (project.blocks == undefined) {
                throw new Error("Given project without blocks defined when updating all styles");
            }
            project.blocks.forEach(function (block) {
                if (block.type !== "Browser" &&
                    block.style &&
                    block.style.clonedFrom === newStyle._id &&
                    block.style.hash === oldStyle.hash) {
                    _this.cloneSavedStyleToBlockAngular(block, newStyle);
                }
            });
        };
        this.clearEmptyObjects = function (o) {
            for (var k in o) {
                if (!o[k] || typeof o[k] !== "object") {
                    continue;
                }
                _this.clearEmptyObjects(o[k]);
                if (Object.keys(o[k]).length === 0) {
                    delete o[k];
                }
            }
        };
        this.migrateStyles = function () { return __awaiter(_this, void 0, void 0, function () {
            var migratedStyles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.styleMigrationService.maybeRunStyleMigration(this.savedStyles)];
                    case 1:
                        migratedStyles = _a.sent();
                        if (migratedStyles.length > 0) {
                            this.savedStyles = migratedStyles;
                        }
                        return [2];
                }
            });
        }); };
        this.styleUrl = "".concat(apiBaseUrl, "/styles");
    }
    SavedStyleService.prototype.getSavedStylesByBlockType = function (blockType) {
        var _this = this;
        return (0, mobx_1.computed)(function () {
            return _this.filterStylesByBlockType(blockType);
        }).get();
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], SavedStyleService.prototype, "savedStyles", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SavedStyleService.prototype, "addStyle", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SavedStyleService.prototype, "deleteStyle", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SavedStyleService.prototype, "renameStyle", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SavedStyleService.prototype, "updateStyle", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SavedStyleService.prototype, "getStylesFromServer", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedStyleService.prototype, "migrateStyles", void 0);
    return SavedStyleService;
}());
exports.default = SavedStyleService;
